import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await register(form.email, form.password, form.name);
    setBusy(false);
    if (r.ok) {
      toast.success("Account created");
      navigate("/account");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="bg-white min-h-[70vh]" data-testid="register-page">
      <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
        <div className="rh-overline mb-3">Account</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Create account</h1>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="block text-xs uppercase tracking-widest text-[#4a4a4a] mb-2">Full name</span>
            <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-[#0a0a0a] px-3 py-3 text-sm" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-widest text-[#4a4a4a] mb-2">Email</span>
            <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-[#0a0a0a] px-3 py-3 text-sm" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-widest text-[#4a4a4a] mb-2">Password (min. 8 chars)</span>
            <input data-testid="reg-password" type="password" minLength={8} required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full border border-[#0a0a0a] px-3 py-3 text-sm" />
          </label>
          <button data-testid="reg-submit" type="submit" disabled={busy} className="rh-btn-primary w-full">{busy ? "Creating…" : "Create Account"}</button>
        </form>

        <p className="mt-6 text-sm text-[#4a4a4a]">
          Already have an account? <Link to="/login" className="underline font-semibold text-[#0a0a0a]">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
